import { put, takeLatest } from "redux-saga/effects";
// import axios from "axios";
import axiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  fakeData: "[fakeData] action",
  selectCoveredCall: "[selectCoveredCall] action",
  selectCoveredCallLoading: "[selectCoveredCallLoading] action",
  selectCoveredCallAsync: "[selectCoveredCallAsync] action",
};
const initialState = {
  prev: [],
  data: [],
  size: 10,
  total: 0,
  loading: false,
};
export const covered_call_reducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.fakeData: {
      let ddd = [...payload, ...state.data];
      return {
        ...state,
        data: ddd,
      };
    }
    case actionTypes.selectCoveredCall:
      return {
        ...state,
        data: payload.results,
        total: payload.total
          ? payload.total > 10000
            ? 10000
            : payload.total
          : 0,
      };
    case actionTypes.selectCoveredCallLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({ type: actionTypes.selectCoveredCallLoading, payload: true });
  const config = {
    url: "select_request",
  };

  const data = {
    table: "option",
    method_type: "select_options_market_watch",
    data: payload?.data ? payload?.data : {},
    from: payload.from ? (payload.from - 1) * payload.size : 0,
    size: payload.size,
    sort_by: payload.sort_by,
  };
  try {
    const res = yield axiosCustom(config, data);
    const isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) return;
    yield put({
      type: actionTypes.selectCoveredCall,
      payload: res.data.response.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({ type: actionTypes.selectCoveredCallLoading, payload: false });
  }
}

export function* coveredCallReducer() {
  yield takeLatest(actionTypes.selectCoveredCallAsync, handleWorker);
}
